// api.js

const state = {
    // State específico del módulo API
  };
  
  const mutations = {
    // Mutations específicas del módulo API
  };
  
  const actions = {
    // Actions específicas del módulo API
    getProductos({commit,state},val) {
      return new Promise((resolve, reject) => {
      fetch(this.state.app.config.apiURL+'productos',
          {
              method: "GET",
                headers: {
                'Authorization': 'Basic ' + btoa(this.state.operador.operador + ':' + this.state.operador.clave), // Aquí incluye las credenciales codificadas en base64
                'Content-Type': 'application/json'
              },
              // body: JSON.stringify({
              //   operador      : val.operador,
              //   clave         : val.clave
              // })
          })
          .then((response) => response.json())
          .then((r) => {
              resolve(r);
          })
          .catch((error) => {
              reject(error);
          });
      },
      error=>{
          reject(error);
      })
    },
   
    getCatalogosProductos({commit,state}) {
      return new Promise((resolve, reject) => {
      fetch(this.state.app.config.apiURL+'catalogos_productos',
          {
              method: "GET",
                headers: {
                'Authorization': 'Basic ' + btoa(this.state.operador.operador + ':' + this.state.operador.clave), // Aquí incluye las credenciales codificadas en base64
                'Content-Type': 'application/json'
              },
              // body: JSON.stringify({
              //   operador      : val.operador,
              //   clave         : val.clave
              // })
          })
          .then((response) => response.json())
          .then((r) => {
              resolve(r);
          })
          .catch((error) => {
              reject(error);
          });
      },
      error=>{
          reject(error);
      })
    },
    createProducto({commit,state},val) {
      return new Promise((resolve, reject) => {
      fetch(this.state.app.config.apiURL+'productos',
          {
              method: "POST",
                headers: {
                'Authorization': 'Basic ' + btoa(this.state.operador.operador + ':' + this.state.operador.clave), // Aquí incluye las credenciales codificadas en base64
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({
                producto     : val,
              })
          })
          .then((response) => response.json())
          .then((r) => {
              resolve(r);
          })
          .catch((error) => {
              reject(error);
          });
      },
      error=>{
          reject(error);
      })
    },
    updateProducto({commit,state},val) {
      return new Promise((resolve, reject) => {
      fetch(this.state.app.config.apiURL+'productos/'+ val.producto_id,
          {
              method: "PUT",
                headers: {
                'Authorization': 'Basic ' + btoa(this.state.operador.operador + ':' + this.state.operador.clave), // Aquí incluye las credenciales codificadas en base64
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({
                producto     : val,
              })
          })
          .then((response) => response.json())
          .then((r) => {
              resolve(r);
          })
          .catch((error) => {
              reject(error);
          });
      },
      error=>{
          reject(error);
      })
    },
    getTiposProductos({commit,state}) {
      return new Promise((resolve, reject) => {
      fetch(this.state.app.config.apiURL+'tipo_producto',
          {
              method: "GET",
                headers: {
                'Authorization': 'Basic ' + btoa(this.state.operador.operador + ':' + this.state.operador.clave), // Aquí incluye las credenciales codificadas en base64
                'Content-Type': 'application/json'
              },
              // body: JSON.stringify({
              //   operador      : val.operador,
              //   clave         : val.clave
              // })
          })
          .then((response) => response.json())
          .then((r) => {
              resolve(r);
          })
          .catch((error) => {
              reject(error);
          });
      },
      error=>{
          reject(error);
      })
    },
    createTipoProducto({commit,state},val) {
      return new Promise((resolve, reject) => {
      fetch(this.state.app.config.apiURL+'tipo_producto',
          {
              method: "POST",
                headers: {
                'Authorization': 'Basic ' + btoa(this.state.operador.operador + ':' + this.state.operador.clave), // Aquí incluye las credenciales codificadas en base64
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({
                tipo_producto     : val,
              })
          })
          .then((response) => response.json())
          .then((r) => {
              resolve(r);
          })
          .catch((error) => {
              reject(error);
          });
      },
      error=>{
          reject(error);
      })
    },
    updateTipoProducto({commit,state},val) {
      return new Promise((resolve, reject) => {
      fetch(this.state.app.config.apiURL+'tipo_producto/'+ val.tipo_producto_id,
          {
              method: "PUT",
                headers: {
                'Authorization': 'Basic ' + btoa(this.state.operador.operador + ':' + this.state.operador.clave), // Aquí incluye las credenciales codificadas en base64
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({
                tipo_producto     : val,
              })
          })
          .then((response) => response.json())
          .then((r) => {
              resolve(r);
          })
          .catch((error) => {
              reject(error);
          });
      },
      error=>{
          reject(error);
      })
    },

  };
  
  const getters = {
    // Getters específicas del módulo API
  };
  
  export default {
    state,
    mutations,
    actions,
    getters
  };